module.exports = __webpack_public_path__ + "static/media/HP_more_boat.273a7bc6.jpg";